import { FournisseurOutput, MarcheTraitantTypeEnum } from '../../../../openapi/build';

export class MarcheTraitant {
  constructor(
    public uuid: string,
    public type: MarcheTraitantTypeEnum,
    public fournisseur: FournisseurOutput | null = null
  ) {}

  static adapt(item: any): MarcheTraitant {
    return new MarcheTraitant(item.uuid, item.type as MarcheTraitantTypeEnum, item.fournisseur ?? null);
  }

  static adaptToApi(item: MarcheTraitant): any {
    return {
      fournisseurUuid: item.fournisseur?.uuid ?? null,
      type: item.type
    };
  }
}
